import { FiMenu } from "react-icons/fi";

export default function Topbar({ title, onOpenSidebar }) {
    return (
        <header className="topbar">
            <div className="topbar-left">
                <button
                    type="button"
                    className="topbar-menu-btn"
                    onClick={onOpenSidebar}
                >
                    <FiMenu size={22} />
                </button>

                <h1>{title}</h1>
            </div>
        </header>
    );
}